import { useState, useEffect, useContext } from "react";
import { CometdActions } from "../../cometD/cometD-action";
import {
  disabledImgWithBtns,
  disablePreviousButton,
} from "../../helpers/index";
import { isNullOrUndefined } from "../../Simplify360Chat/HWLibrary/HWUtils";
import "./LanguageToggle.css";
import { MyContext } from "../../context/Mycontext";

const ALL_LANGUAGES = [
  { name: "English", value: "English" },
  { name: "தமிழ்", value: "Tamil" },
  { name: "ಕನ್ನಡ", value: "Kannada" },
  { name: "తెలుగు", value: "Telugu" },
  { name: "हिंदी", value: "Hindi" },
  { name: "മലയാളം", value: "Malayalam" },
  { name: "मराठी", value: "Marathi" },
  { name: "ਪੰਜਾਬੀ", value: "Punjabi" },
  { name: "ગુજરાતી", value: "Gujarati" },
  { name: "ଓଡିଆ", value: "Oriya" },
  { name: "বাংলা", value: "Bangla" },
]
export default function LanguageToggle(props) {
  const context = useContext(MyContext)
  const [toggle, setToggle] = useState(false);
  const [languages, setLanguages] = useState([{ name: "English", value: "English" }])
  const [selectedlang, setSelectedLang] = useState(
    isNullOrUndefined(JSON.parse(sessionStorage.getItem("selectedLanguage")))
      ? JSON.parse(sessionStorage.getItem("selectedLanguage"))
      : languages[0]
  );
  
  useEffect(() => {
    if (props.config.configDetails?.availableLanguages?.length > 0)
      setLanguages(ALL_LANGUAGES.filter(item => props.config.configDetails.availableLanguages.includes(item.value)))
    else
      setLanguages(ALL_LANGUAGES)
  }, [props.config]);

  useEffect(() => {
    const initialLang = languages[0];
    setSelectedLang(initialLang);
  }, []);

  const onSelectLanguageHandle = (language) => {
    disabledImgWithBtns();
    disablePreviousButton();
    const sessionId = props?.sessionId;
    const { changeLanguageCometd } = CometdActions(context.cometdInstance)
    setSelectedLang(language);
    sessionStorage.setItem("selectedLanguage", JSON.stringify(language));
    changeLanguageCometd(sessionId, language?.value);
  };

  return (
    <div className="languageToggleContainer" onClick={() => setToggle(!toggle)}>
      <h4> {selectedlang?.name}</h4>
      {toggle ? (
        <div className="toggleDropDown">
          {languages.map((oneLang) => (
            <div
              className="oneLanguage"
              onClick={() => onSelectLanguageHandle(oneLang)}
              key={oneLang.value}
            >
              <p>{oneLang.name}</p>
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
}
